// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CalculateMembershipByEntryDateRequestModel from '../../model/calculate-membership-by-entry-date-request-model';
import CalculateMembershipByEntryDateRequestDTO from '../dto/calculate-membership-by-entry-date-request-dto';
import dtoSchema from '../schemas/calculate-membership-by-entry-date-request-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import BasketItemModel from '../../model/basket-item-model';
import OnlinePaymentModel from '../../model/online-payment-model';

export default abstract class CalculateMembershipByEntryDateRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CalculateMembershipByEntryDateRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.businessUnitId = data.businessUnitId;
      this.businessUnitNumber = data.businessUnitNumber;
      this.businessPostalCode = data.businessPostalCode ?? undefined;
      this.membershipCategoryId = data.membershipCategoryId;
      this.payrollCategoryId = data.payrollCategoryId ?? undefined;
      this.grossTotal = data.grossTotal;
      this.currency = data.currency ?? undefined;
      this.items = data.items?.map((i) => BasketItemModel.toModel(i)) ?? [];
      this.periodStart = data.periodStart ?? undefined;
      this.periodEnd = data.periodEnd ?? undefined;
      this.paymentMethod = data.paymentMethod;
      this.onlinePayment = data.onlinePayment ? OnlinePaymentModel.toModel(data.onlinePayment) : undefined;
      this.productDefinitionId = data.productDefinitionId;
      this.membershipEntryDate = data.membershipEntryDate;
      this.isReEntry = data.isReEntry;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {uuid}
  */
  businessUnitId?: string;
  /**
  * @type {int32}
  */
  businessUnitNumber?: number;
  /**
  */
  businessPostalCode?: string;
  /**
  * @type {int32}
  */
  membershipCategoryId?: number;
  /**
  * @type {uuid}
  */
  payrollCategoryId?: string;
  /**
  * @type {double}
  */
  grossTotal?: number;
  /**
  */
  currency?: string;
  /**
  */
  items?: BasketItemModel[];
  /**
  * @type {date-time}
  */
  periodStart?: string;
  /**
  * @type {date-time}
  */
  periodEnd?: string;
  /**
  * @type {int32}
  */
  paymentMethod?: 1 | 2 | 3 | 6 | 7 | 8; // MethodOfPaymentDTO
  /**
  */
  onlinePayment?: OnlinePaymentModel;
  /**
  * @type {uuid}
  */
  productDefinitionId?: string;
  /**
  * @type {date-time}
  */
  membershipEntryDate?: string;
  /**
  */
  isReEntry?: boolean;

  static toModel(dto: DeepPartial<CalculateMembershipByEntryDateRequestDTO>): CalculateMembershipByEntryDateRequestModel;
  static toModel(dto: DeepPartial<CalculateMembershipByEntryDateRequestDTO> | undefined | null): CalculateMembershipByEntryDateRequestModel | undefined;
  static toModel(dto: DeepPartial<CalculateMembershipByEntryDateRequestDTO> | undefined | null): CalculateMembershipByEntryDateRequestModel | undefined {
    return dto ? new CalculateMembershipByEntryDateRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CalculateMembershipByEntryDateRequestModel> | CalculateMembershipByEntryDateRequestModel): CalculateMembershipByEntryDateRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      businessUnitId: unwrapped.businessUnitId,
      businessUnitNumber: unwrapped.businessUnitNumber,
      businessPostalCode: unwrapped.businessPostalCode,
      membershipCategoryId: unwrapped.membershipCategoryId,
      payrollCategoryId: unwrapped.payrollCategoryId,
      grossTotal: unwrapped.grossTotal,
      currency: unwrapped.currency,
      items: unwrapped.items,
      periodStart: unwrapped.periodStart,
      periodEnd: unwrapped.periodEnd,
      paymentMethod: unwrapped.paymentMethod,
      onlinePayment: unwrapped.onlinePayment,
      productDefinitionId: unwrapped.productDefinitionId,
      membershipEntryDate: unwrapped.membershipEntryDate,
      isReEntry: unwrapped.isReEntry,
    } as CalculateMembershipByEntryDateRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CalculateMembershipByEntryDateRequestModel, can not map to CalculateMembershipByEntryDateRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
